// extracted by mini-css-extract-plugin
export default {"section":"Skills_section__+7V4R","slide":"Skills_slide__T7gCI","diva":"Skills_diva__mezNk"};